import {gridFilteredDescendantCountLookupSelector, useGridApiContext, useGridSelector} from "@mui/x-data-grid-pro";
import {Button} from "@mui/material";
import React from "react";
import css_pages from "../pages/css/Pages.module.scss";
import {KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";

export function CustomGridTreeDataGroupingCell(props) {
    const { id, field, rowNode } = props;
    const apiRef = useGridApiContext();
    const filteredDescendantCountLookup = useGridSelector(
        apiRef,
        gridFilteredDescendantCountLookupSelector,
    );

    const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

    const handleClick = (event) => {
        if (rowNode.type !== 'group') {
            return;
        }

        apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
        apiRef.current.setCellFocus(id, field);
        event.stopPropagation();
    };

    return (
        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
            <div style={{marginTop: "0px", marginBottom: "auto", marginLeft: rowNode.depth * 4 * 6}}>
                {filteredDescendantCount > 0 ? (
                    <Button className={css_pages.DropdownButton} style={{marginTop: "10px"}} onClick={(event) => handleClick(event)} startIcon={rowNode.childrenExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}>
                        {filteredDescendantCount > 0 ?  <span style={{color: "#000000", fontWeight: 500, fontSize: "14px"}}>{props.value}</span> : <span style={{color: "#000000", fontWeight: 400, fontSize: "14px"}}>{props.value}</span>}
                    </Button>
                ) : (
                    <span style={{color: "#000000", fontWeight: 400, fontSize: "14px"}}>{props.value}</span>
                )}
            </div>
        </div>
    );
}

